export default __webpack_public_path__ + "static/media/CarImages.RioGallery1.392d60da.jpg";